import { Component, Input, ViewEncapsulation, OnChanges } from '@angular/core';
import { differenceInDays, startOfDay } from 'date-fns';
import { MatProgressBar } from '@angular/material/progress-bar';
import { TranslatePipe } from '@ngx-translate/core';

export type Status =
  | { name: 'Red'; value: 10 }
  | { name: 'Orange'; value: 30 }
  | { name: 'Green'; value: 100 }
  | { name: 'Percentage'; value: 0 };

export function statusFilter(resultProp: number | null, filterValue: Status[]): boolean {
  const check = (value: Status) => {
    return (
      (value.name === 'Red' && resultProp <= 10) ||
      (value.name === 'Orange' && resultProp > 10 && resultProp <= 30) ||
      (value.name === 'Green' && resultProp > 30) ||
      (value.name === 'Percentage' && resultProp <= value.value)
    );
  };

  return filterValue.some(check);
}

@Component({
  selector: 'ma-status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.less'],
  encapsulation: ViewEncapsulation.None,
  imports: [MatProgressBar, TranslatePipe],
})
export class StatusComponent implements OnChanges {
  @Input()
  isSelected: boolean;
  @Input()
  dark: boolean;
  @Input()
  dueDate: Date | string;
  @Input()
  referenceDate: Date | string;
  @Input()
  status: number;

  timespan: number;
  daysLeft: number;
  noOfDays: number;
  info: string;
  statusClass: string;

  ngOnChanges() {
    this.daysLeft = differenceInDays(startOfDay(new Date(this.dueDate)), startOfDay(new Date()));
    this.noOfDays = Math.abs(this.daysLeft);

    if (this.daysLeft < 0) {
      this.info = 'overdue';
    } else if (this.daysLeft >= 0) {
      this.info = 'left';
    }

    if (this.isSelected) {
      this.statusClass = 'progress-white';
    } else {
      if (this.status <= 10) {
        this.statusClass = this.dark ? 'progress-red-dark' : 'progress-red';
      } else if (this.status <= 30) {
        this.statusClass = this.dark ? 'progress-orange-dark' : 'progress-orange';
      } else {
        this.statusClass = this.dark ? 'progress-green-dark' : 'progress-green';
      }
    }
  }
}
